import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link, useHistory } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef()
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  let history = useHistory()

  const logout = () => {
    localStorage.clear()
    history.push("/logout")
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>

            <li>
              <Link to="/dashboard">
                <i className="bx bxs-home"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bxs-dish"></i>
                <span>{props.t("Dishes")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/Category">{props.t("Categories")}</Link>
                </li>
                <li>
                  <Link to="/dishes">{props.t("Dishes")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bxs-user"></i>
                <span>{props.t("Customers List")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/Users">{props.t("Customers")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bxs-alarm"></i>
                <span>{props.t("Bookings")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/PendingBookings">
                    {props.t("Pending Bookings")}
                  </Link>
                </li>
                <li>
                  <Link to="/AcceptedBookings">
                    {props.t("Accepted Bookings")}
                  </Link>
                </li>
                <li>
                  <Link to="/OnTheWayBooking">
                    {props.t("On The Way Bookings")}
                  </Link>
                </li>
                <li>
                  <Link to="/CompletedBookings">
                    {props.t("Completed Bookings")}
                  </Link>
                </li>
                <li>
                  <Link to="/CancelledBookings">
                    {props.t("Cancelled Bookings")}
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bxs-layer"></i>
                <span>{props.t("Payment Managment")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/Payments">{props.t("Payments")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bxs-calendar-event"></i>
                <span>{props.t("Events")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/events">{props.t("Events")}</Link>
                </li>
                <li>
                  <Link to="/gallery">{props.t("Event Gallery")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="fas fa-box-open"></i>
                <span>{props.t("Support")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/PendingSupport">{props.t("Pending Support")}</Link>
                </li>
                <li>
                  <Link to="/SolvedSupport">{props.t("Resolved Support")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/Banners">
                <i className="bx bxs-image-alt"></i>
                <span>{props.t("Banners")}</span>
              </Link>
            </li>

            <li>
              <Link to="/Coupons">
                <i className="bx bxs-badge-check"></i>
                <span>{props.t("Coupons")}</span>
              </Link>
            </li>

            <li>
              <Link to="/Notification">
                <i className="bx bxs-bell-ring"></i>
                <span>{props.t("Notifications")}</span>
              </Link>
            </li>
            <li>
              <Link to="/pos">
                <i className="bx bx-store"></i>
                <span>{props.t("POS")}</span>
              </Link>
            </li>
          

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-user-pin"></i>
                <span>{props.t("Delivery Boys")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/DeliveryBoy">{props.t("New Delivery Boy")}</Link>
                </li>
                <li>
                  <Link to="/deleveryboypsw">{props.t("Request Password")}</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bxs-file"></i>
                <span>{props.t("Reports")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/BookingReport">{props.t("Booking Report")}</Link>
                </li>
                <li>
                  <Link to="/PaymentsReport">{props.t("Payment Report")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bxs-cog"></i>
                <span>{props.t("Settings")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/faq">{props.t("FAQ")}</Link>
                </li>
                <li>
                  <Link to="/leads">{props.t("Leads")}</Link>
                </li>
                <li>
                  <Link to="/testimonials">{props.t("Testimonials")}</Link>
                </li>
                <li>
                  <Link to="/contact">{props.t("Contact Us")}</Link>
                </li>
                <li>
                  <Link to="/aboutus">{props.t("About Us")}</Link>
                </li>
                <li>
                  <Link to="/privacy">{props.t("Privacy Policy")}</Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))